import React from 'react';
import './About.css';
import { Link } from 'react-router-dom'; 


const About = () => {
    return (
        
        <div className="about-container">
            
<Link to="/" className="home-button">Home</Link>

            <h1>About DSADAF</h1>
            <p>
            DSADAF stands for Dynamic Self-Authentication Destruction and Automatic Forwarding. It is a security mechanism designed to enhance the accessibility and security of data in cloud-based systems. The main features of DSADAF include:

<br/>Dynamic Self-Authentication Destruction (DSAD): If a user does not log in within a specified period (e.g., one year), their authentication credentials are permanently destroyed to prevent inactive accounts from posing a security risk.

<br/>Automatic Forwarding (AF): If a user does not log in within a specified period, their authentication credentials are forwarded to a trusted representative's email. If the representative also does not log in within the next specified period (e.g., one year), the authentication credentials are permanently disabled, and the username becomes available for use by anyone.


            </p>
        </div>
    );
};

export default About;
